module.exports = __webpack_public_path__ + "img/FamilyRestroomOutlined.d908909a.svg";